import React from 'react';
import {
  // Form,
  // Select,
  // DatePicker,
  Row,
  Col
  // Typography,
  // Checkbox,
  // Input,
  // Button,
  // Divider,
  // Tabs,
  // Card
} from 'antd';
import styles from './styles.module.less';

const DesiredPartner = ({ profiles }) => {
  const profileData =
    Array.isArray(profiles) && profiles.length > 0
      ? profiles[0]
      : profiles || {};

  const min_age = profileData?.ProfileDesiredPartners?.[0]?.min_age;
  const max_age = profileData?.ProfileDesiredPartners?.[0]?.max_age;

  const min_hight = profileData?.ProfileDesiredPartners?.[0]?.min_height;
  const max_hight = profileData?.ProfileDesiredPartners?.[0]?.max_height;
  // const annual_income =
  //   profileData?.ProfileDesiredPartners?.[0]?.annual_income || 'N/A';
  // const currency =
  //   profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code || 'N/A';
  // const annual_income = profileData?.ProfileDesiredPartners?.[0]?.annual_income
  //   ? Number(
  //       profileData?.ProfileDesiredPartners[0]?.annual_income
  //     ).toLocaleString()
  //   : 'N/A';
  // const annual_income = profileData?.ProfileDesiredPartners?.[0]?.annual_income
  //   ? new Intl.NumberFormat('en-US', {
  //       style: 'currency',
  //       currency: currency
  //     }).format(Number(profileData.ProfileDesiredPartners[0].annual_income))
  //   : 'N/A';
  const annual_income = profileData?.ProfileDesiredPartners?.[0]?.annual_income
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency:
          profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code &&
          profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code !==
            'N/A'
            ? profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code
            : 'INR' // Default to USD if currency is 'N/A' or missing
      }).format(Number(profileData.ProfileDesiredPartners[0].annual_income))
    : 'Not provided';

  const partner_description =
    profileData?.ProfileDesiredPartners?.[0]?.partner_description ||
    'Not provided';

  const familyStatus =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyStatus?.status ||
    'Not provided';
  const familyType =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyType?.type ||
    'Not provided';
  const FamilyValue =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyValue?.values ||
    'Not provided';
  // const location = profileData?.ProfileDesiredPartners?.[0]
  //   ? `${profileData?.ProfileDesiredPartners[0]?.City?.city}, ${profileData?.ProfileDesiredPartners[0]?.Country?.country}`
  //   : 'N/A';
  const City_location =
    profileData?.ProfileDesiredCities?.map((item) => item?.City?.city).join(
      ', '
    ) || 'Not provided';

  const educationData = profileData?.ProfileDesiredPartners?.[0];
  // console.log('educationData', educationData);
  // const partnerEducation = educationData
  //   ?.filter((item) => item.type === 'partner')
  //   ?.map((item) => item?.HigherEducation.education)
  //   ?.join(', ');

  const partnerEducation = educationData?.p_edu?.education;
  // const parentEducation = educationData?.p_edu?.education;
  const p_mother_edu = educationData?.p_mother_edu?.education;
  const p_father_edu = educationData?.p_father_edu?.education;
  // const parentEducation = educationData
  //   ?.filter((item) => item.type === 'partners_parent')
  //   ?.map((item) => item.HigherEducation?.education)
  //   ?.join(', ');

  // console.log('educations_profileData', educations);
  return (
    <>
      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Age Range</span>
          <span className={styles.Dp}>
            {/* {' '}
            {min_age} - {max_age}{' '} */}
            {min_age && max_age ? `${min_age} - ${max_age}` : 'Not provided'}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Height</span>
          <span className={styles.Dp}>
            {/* {' '}
            {min_hight} - {max_hight}{' '} */}
            {min_hight && max_hight
              ? `${min_hight} - ${max_hight}`
              : 'Not provided'}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Annual Income</span>
          <span className={styles.Dp}> {annual_income} </span>
        </Col>
      </Row>

      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Education</span>
          <span className={styles.Dp}>
            {' '}
            {partnerEducation || 'Not provided'}{' '}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Cities</span>
          <span className={styles.Dp}> {City_location} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Family Type</span>
          <span className={styles.Dp}> {familyType} </span>
        </Col>
      </Row>

      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Family Status</span>
          <span className={styles.Dp}> {familyStatus} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Family Values</span>
          <span className={styles.Dp}> {FamilyValue} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Mother Education</span>
          <span className={styles.Dp}> {p_mother_edu || 'Not provided'} </span>
        </Col>

        {/* <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '40%' }}>
            Family Type
          </span>
          <span className={styles.Dp}> {familyType} </span>
        </Col> */}
      </Row>
      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Father Education</span>
          <span className={styles.Dp}> {p_father_edu || 'Not provided'} </span>
        </Col>
      </Row>

      <Row
        style={{
          // marginLeft: '-35px',
          color: '#d20b0b',
          paddingTop: '15px',
          fontFamily: 'teachers'
        }}
      >
        <Col>
          <span
            className={styles.age}
            // className={styles.colStyle}
            style={{ width: '100%', color: '#d20b0b', marginBottom: '4px' }}
          >
            {' '}
            I am looking for
          </span>
          <span
            className={styles.Dp}
            // style={{
            //   fontFamily: 'teachers',
            //   fontSize: '16px'
            // }}
          >
            {partner_description}
          </span>
        </Col>
      </Row>
    </>
  );
};

export default DesiredPartner;
